import UserService from '../Services/userService';

export default class CreateClientPaymentItem {
  CpCcid: string;
  CpLptid: string;
  CpPaymentDate: Date;
  CpDocdate: Date;
  CpRcyid: number;
  CpCheckNumber: string;
  CpAmountPaid: string;
  CpReceivingOfficeId: string;
  CpNotes: string;
  staticClient: number;

  constructor() {
    const officeId: string = UserService.GetOfficeIdOfLoggedInUser();
    this.CpCcid = '';
    this.CpLptid = '';
    this.CpPaymentDate = new Date();
    this.CpDocdate = new Date();
    this.CpRcyid = 0;
    this.CpCheckNumber = '';
    this.CpAmountPaid = '';
    this.CpReceivingOfficeId = officeId;
    this.CpNotes = '';

    this.staticClient = 0;
  }
}
